







import { Component, Provide, Vue } from "vue-property-decorator";
import { IPicture, IArtist } from "@/@types/paintings";
import { pics } from "@/config/host.config";

@Component({})
export default class PaintingModePage extends Vue {
  @Provide() folder = "PaintingMode";

  paintings: Array<IPicture> = [];
  artists: Array<IArtist> = [];
  pictures: Array<string> = [];

  async getPictures(): Promise<void> {
    const url = pics.download;
    const params = { path: this.folder };

    try {
      const paintings = await this.$axios.get(url, { params });
      if (paintings.status === 200) {
        if (
          paintings.data == "Папка не найдена" ||
          paintings.data == "Папка пуста"
        )
          return console.error("Папка не найдена");
        this.pictures = paintings.data;
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getPics(): Promise<void> {
    const url = pics.download;
    const params = {
      "match[deleted][value]": false,
      "match[show][value]": true,
    };

    try {
      const paintings = await this.$axios.get(url, { params });
      if (paintings.status === 200) this.paintings = paintings.data;
    } catch (e) {
      console.log(e);
    }
  }

  async getArtists(): Promise<void> {
    const url = pics.download;
    const params = {
      "match[deleted][value]": false,
      "match[show][value]": true,
    };

    try {
      const artists = await this.$axios.get(url, { params });
      if (artists.status === 200) this.artists = artists.data;
    } catch (e) {
      console.log(e);
    }
  }

  async clear(): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("main.confirms.delete-all")),
        }
      );

      if (result === true) {
        this.paintings.map((cat) => this.deleteElement(cat._id));
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async deleteElement(id: string): Promise<void> {
    if (!id) return;
    const name = id;
    const path = this.folder;
    this.$deliteImage(name, path)
      .then(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        const i = this.paintings.findIndex((pic) => pic._id == id);
        if (i < 0) return;
        else this.paintings.splice(i, 1);
      })
      .catch(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }

  mounted(): void {
    this.getPictures();
  }
}
